import { Component, OnInit } from '@angular/core';
import { AddressBook, AddressBookQuery } from '@fgb/core';
import { Observable } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { map } from 'rxjs/operators';
import { ContactCrudModalComponent } from './modals/contact-crud-modal/contact-crud-modal.component';
@Component({
  selector: 'fgbcl-contacts-management',
  templateUrl: './contacts-management.component.html',
  styleUrls: ['./contacts-management.component.scss'],
})
export class ContactsManagementComponent implements OnInit {
  addressBook$: Observable<AddressBook[]>;

  constructor(
    private addressBookQuery: AddressBookQuery,
    private modalService: NgbModal,
  ) {}

  ngOnInit() {
    this.getAddressBookList();
  }

  /**
   * Fetch the address book list
   */
  getAddressBookList() {
    this.addressBook$ = this.addressBookQuery
      .selectAllContacts()
      .pipe(map((contactsList) => contactsList.sort((a, b) => a.FullName.localeCompare(b.FullName))));
  }

  /**
   * Function to open the CRUD modal, this function will determine what type of operation we want to perform based on the data passed and parameter
   * @param data - with empty data means we want to add a new contact hence Id is null
   * @param data - with data means we want to edit the contact hence Id is not null
   * @param deleteContact - if true, we want to delete the contact
   */
  private _openCrudModal(data: any = {}, deleteContact: boolean = false): void{
    const modalRef = this.modalService.open(ContactCrudModalComponent, { ariaLabelledBy: 'modal-basic-title', windowClass: 'contact-modal-crud', centered: true });
    modalRef.componentInstance.contact = data;
    modalRef.componentInstance.deleteContact = deleteContact;
  }

  /**
   * Open modal to add new contact
   */
  addNewContact(): void{
    // We want to pass empty object to the modal so it will be transformed to contact with Id null, which means the user
    // is a new user, this way we can determine what type of crud operation we want to perform
    // in this case the user is new so we want to add a new contact
    this._openCrudModal();
  }

  /**
   * Open modal to edit existing contact
   */
  editContact(contact: AddressBook): void{
    // This time we pass the contact data to the modal so it will be transformed to contact with Id not null, which means the user
    // is an existing user, this way we can determine what type of crud operation we want to perform
    // in this case the user is existing so we want to edit it
    this._openCrudModal(contact);
  }

  /**
   * Open modal to delete contact
   */
  deleteContact(contact: AddressBook): void{
    this._openCrudModal(contact, true);
  }
}
